import Svg, { SvgProps, Path } from 'react-native-svg';

const LogInIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M15 3C10.346 3 6.308 5.663 4.32 9.545a1 1 0 1 0 1.78.91C7.756 7.22 11.108 5 15 5c5.535 0 10 4.465 10 10s-4.465 10-10 10c-3.892 0-7.244-2.22-8.9-5.455a1 1 0 1 0-1.78.91C6.308 24.337 10.346 27 15 27c6.615 0 12-5.385 12-12S21.615 3 15 3zm-1.01 6.99a1 1 0 0 0-.697 1.717L15.586 14H4a1 1 0 1 0 0 2h11.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l3.912-3.912a1 1 0 0 0-.002-1.592l-3.91-3.91a1 1 0 0 0-.717-.303z" />
  </Svg>
);

export default LogInIcon;
